<template>
  <div id="root">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    if (window.innerWidth < 400 || window.innerWidth > 800) {
      window.document.documentElement.style.fontSize = '36px';
    }
  }
};
</script>
<style lang="scss">
#app {
  height: 100%;
}
</style>
